import { render, staticRenderFns } from "./detalhamento-alocacao-estrategica.vue?vue&type=template&id=02d642ad&"
import script from "./detalhamento-alocacao-estrategica.vue?vue&type=script&lang=js&"
export * from "./detalhamento-alocacao-estrategica.vue?vue&type=script&lang=js&"
import style0 from "./detalhamento-alocacao-estrategica.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDataTable,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02d642ad')) {
      api.createRecord('02d642ad', component.options)
    } else {
      api.reload('02d642ad', component.options)
    }
    module.hot.accept("./detalhamento-alocacao-estrategica.vue?vue&type=template&id=02d642ad&", function () {
      api.rerender('02d642ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/consolidator/components/detalhamento-alocacao-estrategica/detalhamento-alocacao-estrategica.vue"
export default component.exports